// Module
var code = `<div class="alert-selector" style="{{>visibility}}">
    <terceraLabel visible="{{visible}}" text="{{label}}" />

    <div class="alert-selector-right">
        <terceraComboBox showLastValue="true"
                         items="{{items}}"
                         selectedItem="{{selectedItem}}"
                         visible="{{visible}}"
                         enabled="{{enabled}}" />
    </div>
</div>`;
// Exports
export default code;